import AJAX from 'common/AJAX';

/**
 * Utility function for tracking link views.
 * Used by class components that cannot use the useLinkViewTracking hook.
 *
 * @param event - The identifier for the link (e.g., 'clicked_identify_idea_impact_tip')
 * @param path - The path of where the link was clicked
 * @param query - The query when the link was clicked
 */
export const trackLinkView = (event: string, path: string, query: string) => {
  AJAX.post('/api/cannylytics/track', {
    event,
    data: {
      path,
      query,
    },
  });
};

export default trackLinkView;
